(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["choices-led-ticker"] && !Shopify.designMode) return;
  try {
    (() => {
    const resetTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    const returningHome = new URLSearchParams(window.location.search).get('return') === 'home';
    if (returningHome) {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      [0, 80, 260, 640].forEach((delay) => window.setTimeout(resetTop, delay));
      window.addEventListener('load', resetTop, { once: true });
      window.setTimeout(() => window.history.replaceState(null, '', window.location.pathname), 680);
    }

    document.querySelectorAll('[data-choices-home]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const destination = new URL(link.href, window.location.origin);
        if (window.location.pathname !== destination.pathname) return;
        event.preventDefault();
        window.history.replaceState(null, '', destination.pathname);
        resetTop();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
